export function calculateDurationMs(wordCount: number, wpm: number): number {
  if (wordCount <= 0 || wpm <= 0) return 0;
  return Math.round((wordCount / wpm) * 60 * 1000);
}

export function formatDuration(ms: number): string {
  if (ms <= 0) return '0:00';
  const totalSeconds = Math.round(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}

export interface TimelineEntry {
  position: number;
  startTimeMs: number;
  durationMs: number;
  wordCount: number;
  wpm: number;
}

export function calculateTimeline(
  sections: Array<{ wordCount: number; wpm: number; position: number }>,
): { entries: TimelineEntry[]; totalDurationMs: number } {
  let cumulativeMs = 0;
  const entries: TimelineEntry[] = [];

  for (const section of sections) {
    const durationMs = calculateDurationMs(section.wordCount, section.wpm);
    entries.push({
      position: section.position,
      startTimeMs: cumulativeMs,
      durationMs,
      wordCount: section.wordCount,
      wpm: section.wpm,
    });
    cumulativeMs += durationMs;
  }

  return { entries, totalDurationMs: cumulativeMs };
}
